import React, { useState } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
  CreateOrderBalance,
  CreatePercentSelectors,
  CreateOrderField,
  CreateOrderButton,
  BuyLimitInfo,
  CreateOrderFee,
  CommissionPercentageInfo,
  ConfirmOrderModal,
} from 'containers/CreateOrder';
import { withNamespaces } from 'react-i18next';
import { getSingleTradingPairSettings } from 'redux/selectors/settings';
import { Form } from 'components/Form';
import { Text, Box } from 'components/Wrapped';

const marketOrderValidationSchema = (minTradeAmount) => {
  return Yup.object().shape({
    volume: Yup.number()
      .required()
      .min(minTradeAmount),
  });
};

const MarketOrderFormContainer = (props) => {
  const {
    side,
    tradingPair,
    placeOrder,
    placeOrderPriced,
    tradingPairSettings: { tradeAmountDecimals, minTradeAmount },
    lastPrice,
    maxOrderValue,
  } = props;
  const additionalValues = {
    market: tradingPair.quoteCurrency,
    trade: tradingPair.baseCurrency,
  };
  // const t = nestedTranslate(translate, 'forms.marketOrder');
  const [confirmModalVisibility, setConfirmModalVisibility] = useState(false);
  const [currentMode] = useState('volume');

  const onSubmitForm = (values) => {
    if (_.isEqual(currentMode, 'total')) {
      placeOrderPriced({ ...values, side, ...additionalValues });
    } else {
      placeOrder({ ...values, side, ...additionalValues });
    }
  };

  return (
    <Formik
      initialValues={{
        side,
        volume: '',
        type: 'MARKET',
      }}
      validationSchema={marketOrderValidationSchema(minTradeAmount)}
      validateOnChange={true}
      onSubmit={onSubmitForm}
    >
      {(props) => (
        <Form gap="4px">
          <CreateOrderBalance tradingPair={tradingPair} side={side} />

          <Box background="#000D14" direction="row" justify="between" round="8px" pad={{ horizontal: '10px', top: '13px', bottom: '12px' }}>
            <Text color="#B4B6B7" size="12px" weight={600} style={{ lineHeight: '15px' }}>
              Цена
            </Text>
            <Text color="white" size="12px" weight={600} style={{ lineHeight: '15px' }}>
              Маркет
            </Text>
          </Box>

          <CreateOrderField
            type="text"
            name="volume"
            // label={t('volume')}
            label="Всего"
            currency={tradingPair.baseCurrency}
            formProps={props}
            side={side}
            marketCurrentMode="volume"
            precision={tradeAmountDecimals}
          />

          <CreatePercentSelectors marketOrder={true} side={side} total={props.values.total} amount={props.values.volume} />

          <Box pad="none" gap="8px">
            <BuyLimitInfo currency={tradingPair.baseCurrency} maxOrderValue={maxOrderValue} />
            <CreateOrderFee side={side} tradingPair={tradingPair} total={props.values.rate * props.values.volume} />
          </Box>

          <Box pad="none" margin={{ top: '16px' }}>
            <CreateOrderButton
              side={side}
              tradingPair={tradingPair}
              onCreateOrderButtonClick={() => {
                props.validateForm().then((errors) => {
                  if (_.isEmpty(errors)) {
                    setConfirmModalVisibility(true);
                  }
                });
              }}
            />
          </Box>

          <Box pad="none" margin={{ top: '16px' }}>
            <CommissionPercentageInfo />
          </Box>

          <ConfirmOrderModal
            orderType="Маркет"
            tradeMode={side}
            price={lastPrice}
            visible={confirmModalVisibility}
            baseCurrency={tradingPair.baseCurrency}
            quoteCurrency={tradingPair.quoteCurrency}
            amount={props.values.volume}
            onToggleModal={() => {
              setConfirmModalVisibility(!confirmModalVisibility);
            }}
            onСonfirmButtonClick={() => {
              props.submitForm().finally(() => {
                setConfirmModalVisibility(false);
              });
            }}
          />
        </Form>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => ({
  lastPrice: state.exchange.tradingPairStats.lastPrice,
  tradingPairSettings: getSingleTradingPairSettings(state, props),
});

const MarketOrderForm = withNamespaces()(connect(mapStateToProps)(MarketOrderFormContainer));

const MarketOrder = ({ tradingPair, placeOrder, placeOrderPriced, tradeMode }) => {
  return (
    <Box pad={{ vertical: '12px', horizontal: '0px' }}>
      <MarketOrderForm
        tradingPair={tradingPair}
        side={tradeMode === 'buy' ? 'BUY' : 'SELL'}
        placeOrder={placeOrder}
        placeOrderPriced={placeOrderPriced}
      />
    </Box>
  );
};

export default MarketOrder;
